/**
 * Constellation node search (P92).
 *
 * Pure: given the node list + a query, return the set of node ids
 * whose name matches (case-insensitive substring). A 2-char minimum
 * mirrors the topnav typeahead's eligibility floor (P68) so a single
 * stray keystroke doesn't light up half the graph.
 */
import type { TwinNode } from "shared/api/types";

/** Minimum query length before a search is considered active. */
export const SEARCH_MIN_CHARS = 2;

export function matchNodes(nodes: TwinNode[], query: string): Set<string> {
  const q = query.trim().toLowerCase();
  const out = new Set<string>();
  if (q.length < SEARCH_MIN_CHARS) return out;
  for (const n of nodes) {
    if (n.name.toLowerCase().includes(q)) out.add(n.id);
  }
  return out;
}
